"use strict";
exports.__esModule = true;
exports.email = void 0;
var utils_1 = require("../../utils");
var factory_1 = require("../factory");
var validation_1 = require("../validation");
var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var email = function (messageKey) { return function (field, obj) {
    var value = utils_1.Objects.path(field)(obj);
    var valid = utils_1.Objects.isEmpty(value) || emailRegex.test(value);
    return factory_1.ValidationResultFactory.createInstance({
        valid: valid,
        messageKey: messageKey,
        severity: validation_1.ValidationSeverity.error
    });
}; };
exports.email = email;
//# sourceMappingURL=email.js.map